class ConsentService {
  public hasConsent(embedding: string): boolean {
    const needle = embedding.toLowerCase()

    // CCM19 labels carry vendor suffixes ("Matomo Tag Manager"), so an embedding is matched loosely.
    return (window.CCM?.acceptedEmbeddings ?? []).some(
      (accepted): boolean => accepted.name.toLowerCase().includes(needle)
    )
  }

  public onChange(callback: () => void): void {
    for (const eventName of ['ccm19EmbeddingAccepted', 'ccm19WidgetClosed']) {
      window.addEventListener(eventName, callback)
    }
  }

  public openWidget(): void {
    window.CCM?.openWidget?.()
  }
}

export default new ConsentService()
